import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useState } from 'react';

import { mobilityOfferExists } from '@App/pages/Admin/admin.utils';
import { useVacancy } from '@services/query.service';
import { useIsJobCoach } from '@App/components/AuthProvider/auth-provider.context';
import { Button, Icon } from '@nazka/nazka.mapframe.components';
import { faPro } from '@fortawesome/pro-solid-svg-icons';

import MobilityPlanContent from './MobilityPlanContent/MobilityPlanContent';
import MobilityPlanEditModal from './MobilityPlanEditModal/MobilityPlanEditModal';

import { getVerifiedText } from './mobility-plan.utils';

import './mobility-plan.styl';

function MobilityPlan() {
  const vacancy = useSelector(state => state.vacancy);
  const isJobCoach = useIsJobCoach();
  const [showEditModal, setShowEditModal] = useState(false);

  const { companyId } = useParams();

  const OIDN = vacancy?.OIDN || companyId;

  const { data } = useVacancy(OIDN);

  const mobilityOffer = data?.properties?.mobilityOffer;

  const hasMobilityOffer = mobilityOfferExists(mobilityOffer);

  return (
    <div className="mobility-plan">
      {isJobCoach && (!mobilityOffer || mobilityOffer?.verified === false) && (
        <Button
          className="mobility-plan__complete"
          hover={false}
          layout="outlined"
          themeColor="secondary"
          onClick={() => setShowEditModal(!showEditModal)}
        >
          <Icon
            icon={faPro}
            className="mobility-plan__complete__pro"
            size={{
              height: '18px',
              width: '18px',
            }}
          />
          Ken jij meer over het mobiliteitsaanbod van deze werkgever (zoals glijdende uren, douches,
          collectief vervoer of een laadpaal)? Vul het dan hier aan.
        </Button>
      )}
      {hasMobilityOffer && (
        <>
          <h3 className="mobility-plan__title">
            Mobiliteitsaanbod
          </h3>
          <MobilityPlanContent mobilityOffer={mobilityOffer} />
        </>
      )}
      {!hasMobilityOffer && (
        <div className="mobility-plan">
          <p>Het mobiliteitsaanbod van deze werkgever is niet gekend.</p>

          <p>Fiets:</p>
          <ul>
            <li>Fietsvergoeding: sinds mei 2023 is dit in principe verplicht voor alle werkgevers, maar de exacte tussenkomst hangt af van de CAO van de sector.</li>
          </ul>

          <p>Bus, trein, tram, metro</p>
          <ul>
            <li>Een tussenkomst voor het openbaar vervoer is ook (deels) verplicht sinds 2024, maar de exacte tussenkomst hangt af van de CAO van de sector.</li>
          </ul>
        </div>
      )}
      {showEditModal && (
        <MobilityPlanEditModal
          setShowEditModal={setShowEditModal}
          companyId={data.properties.OND_VESTNR}
          OIDN={OIDN}
        />
      )}
      <div className="mobility-plan__footer">
        <p>{getVerifiedText(mobilityOffer)}</p>
      </div>
    </div>
  )
}

export default MobilityPlan;
